module.exports = __webpack_public_path__ + "assets/img/saules-elektriniu-parkas.5493c8b7.jpg";